export const WEBHOOK_EVENTS = {
  project: [
    {
      name: "project.status.change",
    },
  ],
};
